import React from 'react';
import cover from "../IMG/Portfolio Cover.png";
import { Link } from "react-router-dom";

function Left_Intro() {
  return (
    <div className="pb-2 md:pb-6 md:pt-6 px-4 md:w-72 w-full pt-2 rounded-md">
      <div className="relative bg-white shadow-md rounded-md ">
        <img src={cover} alt="Cover" className="rounded-md " />
        <div className=" px-6 pb-6 flex flex-col items-center text-center">
          <h1 className="text-xl font-bold text-gray-900 mb-1">
            Akshat Srivastava
          </h1>
          <p className="text-sm text-gray-700 font-medium mb-4 leading-relaxed line-clamp-4">
            Associate Software Engineer @ U2opia Mobile | Full-Stack Developer | Java, Spring Boot, React, AWS
          </p>
          <p className="text-xs text-gray-500 mb-5 flex items-center justify-center font-medium">
            <svg className="w-3.5 h-3.5 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path></svg>
            Gurugram, HR, India
          </p>
          <Link
            to="/Contact"
            className="w-full text-center block px-6 py-2 bg-blue-600 text-white text-sm font-semibold rounded-full shadow hover:bg-blue-700 transition duration-200"
          >
            Get In Touch
          </Link>
        </div>

      </div>
    </div>
  );
}

export default Left_Intro;